module.exports = __webpack_public_path__ + "img/figure-1.c7e74a56.png";